// extracted by mini-css-extract-plugin
export var closeButton = "Modal-module--closeButton--f4165";
export var externalHolder = "Modal-module--externalHolder--0fa55";
export var innerWrapper = "Modal-module--innerWrapper--f2bd3";
export var wrapper = "Modal-module--wrapper--0fd76";